import React from 'react';
import moment from 'moment';

const Duration = ({ length }) => {
  let result;
  if (length != null) {
    let duration = moment.duration(length, 'seconds');

    if (duration.hours()) {
      result = moment.utc(duration.asMilliseconds()).format('H:mm:ss');
    } else {
      result = moment.utc(duration.asMilliseconds()).format('m:ss');
    }
  }
  return <span>{result}</span>;
};

export default Duration;



// WEBPACK FOOTER //
// ./src/components/layout/Duration.js